module.exports = __webpack_public_path__ + "static/media/emailPreview.779d7386.png";